<list-view *ngIf="boiteLienService.listView" [liste]="boiteLienService.listView"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>